import React from 'react';
import { XCircle } from 'lucide-react';
import AirBoardPage from './AirBoardPage';
import { SUBESTADOS_RECHAZADAS } from '../utils/airBoardConstants';

/** Tablero "Rechazadas" del aéreo — solicitudes en estado `Rechazada`. */
const ACCIONES_ESTADO = [
  {
    key: 'reactivar',
    icon: 'RotateCcw',
    tooltip: 'Reactivar y volver a Cotizaciones',
    confirmar: (codigo) => `¿Reactivar la solicitud ${codigo}? Volverá a Cotizaciones (Borrador).`,
    cambio: { estado: 'Borrador' },
    exito: 'Solicitud reactivada',
    error: 'No se pudo reactivar',
  },
];

export default function RejectedBoardPage() {
  return (
    <AirBoardPage
      estado="Rechazada"
      titulo="Rechazadas"
      subtitulo="Solicitudes en estado Rechazada · canceladas o anuladas"
      icon={XCircle}
      iconClass="bg-rose-100 text-rose-700"
      subEstadoOptions={SUBESTADOS_RECHAZADAS}
      exportFileName="aereo_rechazadas"
      accionesEstado={ACCIONES_ESTADO}
    />
  );
}
